export enum EAppointmentState {
  SCHEDULLED = "SCHEDULLED",
  INQUEUE = "INQUEUE",
  INATTENTION = "INATTENTION",
  COMPLETED = "COMPLETED",
  MISSED = "MISSED",
  CANCELLED_BY_PATIENT = "CANCELLED_BY_PATIENT",
  CANCELLED_PENDING_CONTACT = "CANCELLED_PENDING_CONTACT",
  CANCELLED_AND_NOTIFIED = "CANCELLED_AND_NOTIFIED",
  RESCHEDULLED = "RESCHEDULLED",
  PENDING_ATTENTION = "PENDING_ATTENTION",
  IN_OBSERVATION = "IN_OBSERVATION",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAID = "PAID",
  CONFIRMED = "CONFIRMED"
}

// DEFINE UN TIPO DE OBJETO Y LUEGO LE ASIGNA VALORES
export const EAppointmentStateValues: { [key in EAppointmentState]: number } = {
  [EAppointmentState.SCHEDULLED]: 1,
  [EAppointmentState.INQUEUE]: 2,
  [EAppointmentState.INATTENTION]: 3,
  [EAppointmentState.COMPLETED]: 4,
  [EAppointmentState.MISSED]: 5,
  [EAppointmentState.CANCELLED_BY_PATIENT]: 6,
  [EAppointmentState.CANCELLED_PENDING_CONTACT]: 7,
  [EAppointmentState.CANCELLED_AND_NOTIFIED]: 8,
  [EAppointmentState.RESCHEDULLED]: 9,
  [EAppointmentState.PENDING_ATTENTION]: 10,
  [EAppointmentState.IN_OBSERVATION]: 11,
  [EAppointmentState.PENDING_PAYMENT]: 12,
  [EAppointmentState.PAID]: 13,
  [EAppointmentState.CONFIRMED]: 14,
};

  function getKeyByValue(value: number): string|null {
      const entries = Object.entries(EAppointmentStateValues);
      const foundEntry = entries.find(([_, val]) => val === value);
      return foundEntry ? foundEntry[0] : null;
  }

  // Función para obtener la cadena de texto del estado basado en el valor numérico
  export function getAppointmentStateStringById(id: number): string {
      const stateKey = getKeyByValue(id);
      console.log(id)
      console.log(stateKey);
      return stateKey ? stateKey : 'Error'; // stateKey será la cadena de texto del enum si se encuentra, undefined en caso contrario
  }